/** Angular */
import { Inject, Injectable, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
/** Configs */
import { BYD_TRANSLATE_INJECTION_TOKEN } from '../configs/byd-translate-injection-token';
/** Enums */
import { BydTranslateEnum } from '../enums/byd-runtime.enum';
/** Interfaces */
import { BydTranslateInterface } from '../interfaces/byd-translate.interface';

@Injectable({
  providedIn: 'root',
})
export class BydTranslateService {
  /**
   * Creates an instance of BydTranslateService.
   *
   * @param translate the ngx translate service.
   * @param bydTranslate The data injected from the beyond translate injection token `BYD_TRANSLATE_INJECTION_TOKEN`
   */
  constructor(
    private translate: TranslateService,
    @Optional() @Inject(BYD_TRANSLATE_INJECTION_TOKEN) public bydTranslate?: BydTranslateInterface
  ) {}

  /**
   * Changes the language currently used.
   *
   * @returns Observable
   */
  public use(): Observable<unknown> {
    return this.translate.use(this.bydTranslate?.language || BydTranslateEnum.DEFAULT_LANGUAGE);
  }
}
